import React, {Component} from "react"
import PaperBlock from "../../ui/PaperBlock"
import { List, ListItem, ListItemIcon, ListItemText } from "@material-ui/core"
import ItemIcon from '@material-ui/icons/Attachment'
import FolderIcon from '@material-ui/icons/Folder'
import BackIcon from '@material-ui/icons/KeyboardReturn'

/**
 * items
 * selected
 * folder_id
 * 
 * onItemClick(attachment)
 * onItemDoubleClick(attachment)
 * onBackClick(folder_id)
 */

class ItemsList extends Component {

    render() {
        return <PaperBlock style={{width: "auto"}}>
            <List>
                {this.props.folder_id ? 
                    <ListItem 
                        button
                        onDoubleClick = {e => {
                            e.stopPropagation()
                            if (typeof this.props.onBackClick === "function") {
                                this.props.onBackClick(this.props.folder_id)
                            }
                        }}
                    >
                        <ListItemIcon>
                            <BackIcon/>
                        </ListItemIcon>
                        <ListItemText primary = {".."}/>
                    </ListItem>
                : undefined}
                {this.props.items.map((item, key) => 
                    <ListItem
                        key = {key}
                        button
                        selected = {this.props.selected ? this.props.selected.id === item.id : false} 
                        onClick = {e => {
                            e.stopPropagation()
                            if (typeof this.props.onItemClick === "function") {
                                this.props.onItemClick(item)
                            }
                        }}
                        onDoubleClick = {e => {
                            e.stopPropagation()
                            if (typeof this.props.onItemDoubleClick === "function") {
                                this.props.onItemDoubleClick(item)
                            }
                        }}
                    >
                        {item.type === 0 ? <ListItemIcon><FolderIcon/></ListItemIcon> : <ListItemIcon><ItemIcon/></ListItemIcon>}
                        <ListItemText primary = {item.name}/>
                    </ListItem>
                )}
            </List>
        </PaperBlock>
    }

}

export default ItemsList